// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    interactionJti: z.string().max(128).nullable().optional(),
    phone: z.string().min(1).max(13),
    purpose: z.string().min(1).max(32),
    codeHash: z.string().min(1).max(60),
    language: z.string().min(1).max(35).optional(),
    failedAttempts: z.number().optional(),
    expiresAt: z.number(),
    consumedAt: z.number().nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    interactionJti: z.string().max(128).nullable(),
    phone: z.string().min(1).max(13),
    purpose: z.string().min(1).max(32),
    codeHash: z.string().min(1).max(60),
    language: z.string().max(35),
    failedAttempts: z.number(),
    expiresAt: z.number(),
    consumedAt: z.number().nullable(),
    createdAt: z.number(),
});
export const PhonePasscodes = Object.freeze({
    table: 'phone_passcodes',
    tableSingular: 'phone_passcode',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        interactionJti: 'interaction_jti',
        phone: 'phone',
        purpose: 'purpose',
        codeHash: 'code_hash',
        language: 'language',
        failedAttempts: 'failed_attempts',
        expiresAt: 'expires_at',
        consumedAt: 'consumed_at',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'interactionJti',
        'phone',
        'purpose',
        'codeHash',
        'language',
        'failedAttempts',
        'expiresAt',
        'consumedAt',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
